module.exports = __webpack_public_path__ + "static/img/review-icon.ab893fef.svg";